import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
import { setInteractionMode } from "vee-validate";
// SYSTEM1
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import EmployeeModule from "@/store/modules/employee.module";
import Loader from "../../../components/widgets/loader.vue";
import SectionLoader from "../../../components/widgets/SectionLoader.vue";
/**
 * View Employee Component
 */
setInteractionMode("passive");
Component.registerHooks(["metaInfo"]);
let ViewEmployee = /** @class */ (() => {
    let ViewEmployee = class ViewEmployee extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.pageIsLoading = true;
            this.isPageLoading = false;
            this.title = "View Employee";
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Employees",
                    to: "/employees",
                },
                {
                    text: "View Employee",
                    active: true,
                },
            ];
            this.ctaButtons = [
                {
                    routeName: "Employees",
                },
            ];
        }
        //Methods
        //Computed
        get employees() {
            return EmployeeModule.employee;
        }
        // Skills are stored as one free-text value; split on commas for display
        get skillList() {
            if (!this.employees || !this.employees.skills) {
                return [];
            }
            return this.employees.skills
                .split(",")
                .map((skill) => skill.trim())
                .filter((skill) => skill.length > 0);
        }
        //Lifecycle
        // Generate Pdf of an Employee
        GeneratePdf(employeeId) {
            this.isPageLoading = true;
            EmployeeModule.GeneratePdfById(employeeId).then((response) => {
                if (response) {
                    const blob = new Blob([response], { type: "application/pdf" });
                    const link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    document.body.appendChild(link);
                    link.download = `(${this.employees.firstName}).pdf`;
                    link.click();
                    this.isPageLoading = false;
                }
            });
        }
        created() {
            var employeeId = parseInt(this.$route.params.employeeId);
            EmployeeModule.ViewEmployee(employeeId).then((response) => {
                this.pageIsLoading = false;
            });
        }
    };
    ViewEmployee = __decorate([
        Component({
            name: "ViewEmployee",
            components: {
                Layout,
                PageHeader,
                SectionLoader,
                Loader,
            },
        })
    ], ViewEmployee);
    return ViewEmployee;
})();
export default ViewEmployee;
